import { useChatContext } from '../hooks/useChat';

interface HeaderProps {
  showBack: boolean;
  onBack: () => void;
  onNewChat: () => void;
  onHistory: () => void;
}

export default function Header({ showBack, onBack, onNewChat, onHistory }: HeaderProps) {
  const { connectionState } = useChatContext();

  return (
    <header className="flex items-center justify-between px-4 py-3 border-b border-gray-100 bg-white">
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            onClick={onBack}
            className="p-1.5 -ml-1.5 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Go back"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
        )}

        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white text-sm font-medium">
            F
          </div>
          <div>
            <h1 className="text-sm font-semibold text-gray-900">Chat Support</h1>
            <div className="flex items-center gap-1.5">
              <span
                className={`w-2 h-2 rounded-full ${
                  connectionState === 'connected'
                    ? 'bg-green-500'
                    : connectionState === 'connecting'
                    ? 'bg-yellow-500'
                    : 'bg-gray-300'
                }`}
              />
              <span className="text-xs text-gray-500">
                {connectionState === 'connected'
                  ? 'Online'
                  : connectionState === 'connecting'
                  ? 'Connecting...'
                  : 'Offline'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={onHistory}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="View history"
          title="Conversation history"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </button>

        <button
          onClick={onNewChat}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="New chat"
          title="Start new chat"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
        </button>

        <button
          onClick={() => window.parent.postMessage({ type: 'fanks:close' }, '*')}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="Close"
          title="Close"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </header>
  );
}
